import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.css'],
})
export class ConfirmModalComponent {
  @Input() headerText: string;
  @Input() bodyText: string;
  @Input() confirmButtonText = 'Confirm';
  @Input() cancelButtonText = 'Cancel';
  @Input() onConfirm: Function | null;
  @Input() warningLevel: string | null = null;
  confirmed = false;

  constructor(private ngbActiveModal: NgbActiveModal) {}

  saveAndCloseModal() {
    this.confirmed = true;
    if (this.onConfirm) {
      this.onConfirm();
    }
    this.closeModal();
  }

  closeModal() {
    this.ngbActiveModal.close(this.confirmed);
  }
}
